<template>
  <div class="contact-us full-screen">
        <!-- content -->
        <div class="wrapper-full-page section content">
            <div>
                <div class="container">
                    <b-alert class="mt-5 mb-0 font-en" show variant="">
                        <img class="mb-2 mt-0" src="@/assets/img/election_logo.png" alt="MUIC">
                    </b-alert>
                    <div class="mt-3 row">
                        <div class="col-md-6">
                            <img class="mb-3 mt-0 img-fluid" src="@/assets/img/404img.png" alt="MUIC">
                        </div>
                        <div class="col-md-6">
                            <b-alert class="shadow" show variant="secondary">
                                <h1 class="font-weight-bold mt-0 mb-1 text-danger font-404-page">
                                    Sorry !
                                </h1>
                                <h2 class="mt-3 mb-1 text-danger font-404-page">
                                    The page you are looking for is not here.
                                </h2>
                                <h2 class="mt-0 mb-1 text-danger font-404-page">
                                    Let me try again!
                                </h2>
                                <div class="mt-3 mb-3">
                                    <b-link variant="info" size="sm" to="/portal">
                                        <h3 class="mt-0 font-blue mb-0">GO TO HOME<i class="fa fa-arrow-circle-right ml-3"></i></h3>
                                    </b-link> 
                                </div>
                            </b-alert>
                            <small>{{ ChkText !== null ? ChkText : '' }}</small>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- content -->
    </div>
</template>

<style lang="scss" scoped>
    // @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
    .alert-danger {
        background-color: #f1d1d1;
        color: #000000;
    }
    .font-404-page{ font-family: 'Baloo Tamma 2', cursive;}
    .alert-secondary {
        color: #383d41;
        background-color: #f5f5f5;
        border-color: #d6d8db;
    }
    .font-blue{
        color: #000071;
    }
</style>

<script>
  export default {
        props: {
            ChkText: { type: String, default: null },
        },
  };
</script>
